import React from 'react';
import { View } from '@react-pdf/renderer';

const MARK_THICKNESS = 1.5;
const MARK_BORDER_WIDTH = 0.5;
const MARK_STYLE = `${MARK_BORDER_WIDTH}pt solid white`;

const PdfCropMark = ({
  orientation,
  location,
  length,
}: {
  orientation: 'horizontal' | 'vertical';
  length: number;
  location: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}): JSX.Element => {
  if (orientation === 'horizontal') {
    const horizontalLocations = {
      'top-left': {
        top: length,
        left: 0,
      },
      'top-right': {
        top: length,
        right: 0,
      },
      'bottom-left': {
        bottom: length,
        left: 0,
      },
      'bottom-right': {
        bottom: length,
        right: 0,
      },
    };
    return (
      <View style={{
        width: length,
        height: MARK_THICKNESS,
        backgroundColor: 'black',
        borderTop: MARK_STYLE,
        borderBottom: MARK_STYLE,
        position: 'absolute',
        ...horizontalLocations[location],
      }}></View>
    );
  } else {
    // Default to vertical
    const verticalLocations = {
      'top-left': {
        top: 0,
        left: length,
      },
      'top-right': {
        top: 0,
        right: length,
      },
      'bottom-left': {
        bottom: 0,
        left: length,
      },
      'bottom-right': {
        bottom: 0,
        right: length,
      },
    };
    return (
      <View style={{
        width: MARK_THICKNESS,
        height: length,
        backgroundColor: 'black',
        position: 'absolute',
        borderLeft: MARK_STYLE,
        borderRight: MARK_STYLE,
        ...verticalLocations[location],
      }}></View>
    );
  }
};

export default PdfCropMark;
